export interface DocumentValidationStatus {
  status: string;
  validationResults: ValidationResults[];
}

export interface ValidationResults {
  subject: string;
  status: string;
  text: string;
  type?: string;
}

export const VALIDATION_TYPES = [
  'HTML',
  'NUMBERED CITATIONS',
  'UNNUMBERED CITATIONS',
] as const;

export interface ValidationGroup {
  name: string;
  status: 'error' | 'success';
  errorCount: number;
  results: ValidationResults[];
}

export interface ValidateApiResponse {
  jobId: number;
  message: string;
}

export interface CitationEntry {
  'apollo:validationResults'?: ValidationResults[];
}
